<template>
    <div class="privacy-popup-overlay" v-if="visible">
        <!-- 第一层弹窗：服务协议和隐私政策 -->
        <div class="privacy-popup" v-if="step === 1">
            <div class="privacy-popup-title">{{ title }}</div>
            <div class="privacy-popup-body">
                <div class="privacy-popup-message" v-html="message"></div>
            </div>
            <div class="privacy-popup-btns">
                <button class="privacy-btn privacy-btn-refuse" @click="onRefuse">{{ buttonRefuse }}</button>
                <button class="privacy-btn privacy-btn-accept" @click="onAccept">{{ buttonAccept }}</button>
            </div>
        </div>

        <!-- 第二层弹窗：确认提示（用户首次拒绝后展示） -->
        <div class="privacy-popup" v-if="step === 2">
            <div class="privacy-popup-title">{{ secondTitle }}</div>
            <div class="privacy-popup-body">
                <div class="privacy-popup-message" v-html="secondMessage"></div>
            </div>
            <div class="privacy-popup-btns">
                <button class="privacy-btn privacy-btn-refuse" @click="onExit">{{ secondButtonRefuse }}</button>
                <button class="privacy-btn privacy-btn-accept" @click="onAccept">{{ secondButtonAccept }}</button>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 隐私协议弹窗组件
 * 参考 androidPrivacy.json 的交互逻辑：
 * 1. 首次进入展示"服务协议和隐私政策"弹窗
 * 2. 用户点击"暂不同意"后展示二次确认弹窗
 * 3. 用户点击"同意并接受"/"同意并继续"后记录同意状态并关闭
 * 4. 用户点击"退出应用"则退出（Web端关闭页面）
 *
 * 使用方式：在 login.vue 或其他入口页面引入此组件即可
 * <privacy-popup ref="privacyPopup" />
 * 组件会自动检查 localStorage.privacyAgreed 判断是否需要弹出
 */
export default {
    name: 'privacyPopup',
    data() {
        return {
            visible: false,
            step: 1,
            // 第一层弹窗文案（对应 androidPrivacy.json）
            title: '服务协议和隐私政策',
            message: `　　请你务必审慎阅读、充分理解<a href="https://www.dianzhangbao.net/Protocol/user_privacy" style="color:#FE724F;">《服务协议》</a>和<a href="https://www.dianzhangbao.net/Protocol/vip_privacy_policy" style="color:#FE724F;">《隐私政策》</a>各条款，包括但不限于：为了更好的向你提供服务，我们需要收集你的设备标识、操作日志等信息用于分析、优化应用性能。<br/>　　你可阅读上述协议了解详细信息。如果你同意，请点击下面按钮开始接受我们的服务。`,
            buttonAccept: '同意并接受',
            buttonRefuse: '暂不同意',
            // 第二层弹窗文案（对应 androidPrivacy.json second）
            secondTitle: '确认提示',
            secondMessage: `　　进入应用前，你需先同意<a href="https://www.dianzhangbao.net/Protocol/user_privacy" style="color:#FE724F;">《服务协议》</a>和<a href="https://www.dianzhangbao.net/Protocol/vip_privacy_policy" style="color:#FE724F;">《隐私政策》</a>，否则将退出应用。`,
            secondButtonAccept: '同意并继续',
            secondButtonRefuse: '退出应用',
        };
    },
    methods: {
        /**
         * 检查是否需要展示隐私弹窗
         * 返回 true 表示需要展示（用户未曾同意过）
         */
        checkNeedShow() {
            const agreed = localStorage.getItem('privacyAgreed');
            return agreed !== '1';
        },
        /**
         * 展示隐私弹窗（由父组件调用或自动调用）
         */
        show() {
            if (this.checkNeedShow()) {
                this.visible = true;
                this.step = 1;
            }
        },
        /**
         * 用户点击"同意并接受" / "同意并继续"
         */
        onAccept() {
            localStorage.setItem('privacyAgreed', '1');
            this.visible = false;
            this.$emit('accepted');
        },
        /**
         * 用户点击"暂不同意" → 展示二次确认弹窗
         */
        onRefuse() {
            this.step = 2;
        },
        /**
         * 用户点击"退出应用"
         * Web端：尝试关闭页面，若无法关闭则跳转至空白页
         */
        onExit() {
            this.visible = false;
            this.$emit('refused');
            // 尝试关闭窗口
            try {
                if (window.close) {
                    window.close();
                }
                // 如果 window.close 无效（非脚本打开的窗口），跳转空白页
                setTimeout(() => {
                    window.location.href = 'about:blank';
                }, 300);
            } catch (e) {
                window.location.href = 'about:blank';
            }
        },
    },
    mounted() {
        // 组件挂载后自动检查并展示
        // TODO: 暂时隐藏隐私弹窗
        // this.$nextTick(() => {
        //     this.show();
        // });
    },
};
</script>

<style lang="less" scoped>
.privacy-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.privacy-popup {
    background: #FFFFFF;
    border-radius: 0.13rem;
    width: 80%;
    max-width: 8.5rem;
    padding: 0.5rem 0.45rem 0.4rem;
    box-sizing: border-box;
    animation: privacyFadeIn 0.25s ease;
}

@keyframes privacyFadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

.privacy-popup-title {
    font-size: 0.42rem;
    font-weight: bold;
    color: #000000;
    text-align: center;
    margin-bottom: 0.35rem;
    line-height: 1.4;
}

.privacy-popup-body {
    max-height: 50vh;
    overflow-y: auto;
    margin-bottom: 0.35rem;
}

.privacy-popup-message {
    font-size: 0.34rem;
    color: #333333;
    line-height: 1.7;
    word-break: break-all;

    /deep/ a {
        color: #FE724F;
        font-size: inherit;
        text-decoration: none;
    }
}

.privacy-popup-btns {
    display: flex;
    justify-content: center;
    gap: 0.3rem;
}

.privacy-btn {
    flex: 1;
    height: 0.96rem;
    border-radius: 0.13rem;
    font-size: 0.38rem;
    border: none;
    outline: none;
    cursor: pointer;
    font-weight: 500;
    max-width: 3.6rem;
}

.privacy-btn-accept {
    background: #FE724F;
    color: #FFFFFF;
}

.privacy-btn-refuse {
    background: #F5F5F5;
    color: #000000;
    border: 1px solid #E5E5E5;
}
</style>



// WEBPACK FOOTER //
// src/components/privacyPopup.vue